import { pageFactory } from '../support';

export const ConfirmModal = pageFactory({
  url: '',
  selectors: {
    delete: 'Confirm Modal Danger Button',
  },
});
